import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Projects a body-cell template into {@link TrTableComponent}, keyed by column.
 *
 * Usage: `<ng-template trCell="name" let-row let-i="index" let-col="column"> … </ng-template>`.
 * The template's context is `{ $implicit: row, index, column }`.
 */
@Directive({
  selector: '[trCell]',
  standalone: false,
})
export class TrCellDirective {
  /** Column key this cell renders (matches `TrColumn.key`). */
  @Input('trCell') key!: string;

  constructor(public readonly template: TemplateRef<unknown>) {}
}
